
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { CommonService } from '../../../services/common.service';
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';

@Component({
  selector: 'app-cost-center-list',
  templateUrl: './../../../templates/forms/modals/customer-list.component.html',
})
export class CustomerListComponent implements OnInit {
  @Input()
  modalShow: boolean = true;


  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj: any;

  customerList = [];

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "CustomerListGrid";

  searchFields: any[] = ['CUSTOMER_NAME', 'CUSTOMER_ID'];
  public searchString;
  constructor(private dataService: CommonService,
    public langService: LangService,
    public gridService: GridService) {
    this.colObj = [
      { headerName: langService.langData.customerName, filter: true, field: 'CUSTOMER_NAME', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.customerId, field: 'CUSTOMER_ID', sortable: true, filter: true, resizable: true, hide: false },
    ];
  }

  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
  }


  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);
    this.dataService.getCustomers()
      .subscribe(arg => { console.log(arg); this.customerList = arg.body });
  }

  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next(_item);
  }
}


